/**
 * monthEndWindow — pure date helper for the WL-F1 "Monatsende-Banner"
 * (modules-loop-b.md WL-F1): decides whether `date` falls within the last
 * `windowDays` days of its month.
 *
 * Pure function, no I/O — trivially testable (golden-rules.md "Pure functions
 * bevorzugen").
 *
 * @module utils/monthEndWindow
 */

/** Default banner window: the last 5 calendar days of the month. */
export const MONTH_END_WINDOW_DAYS = 5;

/**
 * `true` when `date`'s day-of-month falls within the last `windowDays` days of
 * that month (inclusive of the last day itself).
 *
 * @param date - the date to check (local time; the caller controls timezone).
 * @param windowDays - size of the trailing window in days (default {@link MONTH_END_WINDOW_DAYS}).
 * @returns `true` if `date` is within the month-end window.
 */
export function isWithinMonthEndWindow(
  date: Date,
  windowDays: number = MONTH_END_WINDOW_DAYS,
): boolean {
  if (Number.isNaN(date.getTime()) || windowDays <= 0) return false;
  const daysInMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  return date.getDate() > daysInMonth - windowDays;
}
